import http from "../../../services/http";
import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import {
  IAPI_FAC014_Request,
  IAPI_FAC014_Response,
  IAPI_FAC027_Request,
  IAPI_FAC027_Response,
  IAPI_FAC034_Request,
  IAPI_FAC034_Response,
} from "../../../type/apiType";

// 施設等新設届一覧参照
const httpAPI_FAC034 = async (
  param: IAPI_FAC034_Request
): Promise<IAPI_FAC034_Response> => {
  let res = await http.post(ApiUrl.API_FAC034, {
    ...param,
  });
  return res.data;
};

// 施設表示順更新(施設等新設届)
const httpAPI_FAC027 = async (
  param: IAPI_FAC027_Request
): Promise<IAPI_FAC027_Response> => {
  let res = await http.post(ApiUrl.API_FAC027, {
    ...param,
  });
  return res.data;
};

// 施設情報削除
const httpAPI_FAC014 = async (
  param: IAPI_FAC014_Request
): Promise<IAPI_FAC014_Response> => {
  let res = await http.post(ApiUrl.API_FAC014, {
    ...param,
  });
  return res.data;
};

export { httpAPI_FAC034, httpAPI_FAC027, httpAPI_FAC014 };
